import {
  ButtonGroup,
  List,
  ListItem,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
  Link,
} from "@certn/cascadia-react";
import { weights } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

export function PrimaryInfoModal() {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={() => (
        <Link
          textStyle="global/body-secondary"
          textColor="text-info"
          testID="identification-documents-primary-document-whats-this-button"
        >
          <Trans>What's this?</Trans>
        </Link>
      )}
    >
      {(close) => (
        <LegacyModal>
          <ModalHeader close={close} title={t("Primary document")} />
          <ModalContent>
            <Text style="global/body-primary">
              <Trans>
                Primary use in the community documents. The following documents
                are accepted:
              </Trans>
            </Text>
            <br />
            <br />
            <List type="unordered">
              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Current Australian passport
                  </strong>
                  , not expired, (however, if the Document Verification Service
                  (DVS) is used to verify the passport, it may be up to 2 years
                  expired)
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Current Australian drivers licence, learner permit or
                    provisional licence
                  </strong>{" "}
                  issued by a state or territory, showing a signature and/or
                  photo and the same name as claimed
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    ImmiCard
                  </strong>{" "}
                  issued by Department of Home Affairs that enables the
                  cardholder to prove their visa and/or migration status and
                  enrol in services
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian marriage certificate
                  </strong>{" "}
                  issued by a state or territory (church or celebrant-issued
                  certificates are not accepted)
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Current passport
                  </strong>{" "}
                  issued by a country other than Australia with a valid entry
                  stamp or visa
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Current proof of age with photo or photo identity card
                  </strong>{" "}
                  issued by an Australian Government agency in the name of the
                  applicant, with a photo
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Current shooter or firearms licence
                  </strong>{" "}
                  showing a signature and photo (not minor or junior permit or
                  licence)
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Current student identification card
                  </strong>{" "}
                  with a signature or photo. For persons under 18 years of age
                  with no other Primary Use in Community Documents
                </Trans>
              </ListItem>
            </List>
          </ModalContent>
          <ModalFooter>
            <ButtonGroup>
              <PrimaryButton onPress={close} size="medium">
                <Trans>Okay</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}
